<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">S1 Sum Filtered</strong>
        </div>
        <div class="col-md-2">
          <download :tableId="'s1s'" :fileName="'s1s'"></download>
        </div>
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <datepicker
                  disabled
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="ddate"
                  @selected="getDateData($event)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <button @click="addFilter" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-plus" title="Filter"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8" v-for="(di, index) in addedFilter" v-bind:key="di.title+index">
              <div class="row">
                <div class="col-md-5" v-if="searchData.length>0">
                  <div class="form-group">
                    <select
                      class="form-control"
                      v-model="selectedFil[index]"
                      name="raw-data-columns"
                      @change="getFilterType(index)"
                    >
                      <option
                        v-for="(d, ind) in filterOptions"
                        v-bind:key="d.id+index"
                        :value="ind"
                      >{{d.value}}</option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-md-3"
                  v-if="searchData.length>0 && selctedFiltersValue[index] === null"
                >
                  <div class="form-group">
                    <input class="form-control" v-model="min[index]" placeholder="Min" />
                  </div>
                </div>
                <div
                  class="col-md-3"
                  v-if="searchData.length>0 && selctedFiltersValue[index] === null"
                >
                  <div class="form-group">
                    <input class="form-control" v-model="max[index]" placeholder="Max" />
                  </div>
                </div>
                <div
                  class="col-md-6"
                  v-if="searchData.length> 0 && selctedFiltersValue[index] !== null"
                >
                  <div class="form-group">
                    <!-- <select
                      class="form-control"
                      v-model="textFilters[index]"
                      name="raw-data-columns"
                      multiple
                    >
                      <option value>Select Value</option>
                      <option
                        v-for="(d, indx) in selctedFiltersValue[index]"
                        v-bind:key="d.title+indx"
                        :value="d.title"
                      >{{d.name}}</option> 
                    </select>-->
                    <v-select
                      :options="selctedFiltersValue[index]"
                      :placeholder="'Select'"
                      v-model="textFilters[index]"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      label="name"
                      track-by="title"
                      :preselect-first="false"
                      select-label
                      selectedLabel
                      deselectLabel
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-1" v-if="index>0">
                  <div class="form-group">
                    <button
                      @click="removeFilter(index)"
                      class="btn btn-sm btn-danger"
                      type="button"
                    >
                      <i class="fa fa-remove" title="Remove"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1" v-if="addedFilter.length>0 && searchData.length>0">
              <div class="form-group">
                <button @click="filtData" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-filter" title="Filter"></i>
                </button>
              </div>
            </div>
            <div class="col-md-1" v-if="addedFilter.length>0 && searchData.length>0">
              <div class="form-group">
                <button @click="refreshData" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-refresh" title="Reset"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            />
          </div>
        </div>
      </div>
      <div class="table-responsive mb-15 app" v-dragscroll="true">
        <table id="s1s" class="table table-bordered app-inner" style="font-size: 11px;">
          <thead v-if="tableFields.length>0">
            <tr>
              <th>Sr.</th>
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody v-if="tableFields.length>0">
            <tr v-for="(row, index, key) in rawData" v-bind:key="'row'+row+index">
              <!-- <td>{{(parseInt(page)===1)? (index+1):(((parseInt(page)-1)*perPage)+(index+1))}}</td> -->
              <td>{{(index+1)}}</td>
              <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-td-'+index+key">
                <span
                  v-if="field.title === 'q1_a_b_greater' || field.title === 'p11_quarterly_trends' || field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization' || field.title === title"
                >
                  <span v-if="field.isLink">
                    <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                  </span>
                  <span
                    v-else
                  >{{(field.isNumeric)? getChecknFixed(row[field.title]): row[field.title]}}</span>
                </span>
                <span v-else>
                  <span
                    v-if="field.title==='latest_cyclical'"
                    :class="(row['s1_data'][field.title] === 1)? 'fred': (row['s1_data'][field.title]===0)? 'fgreen': ''"
                  >{{(row['s1_data'][field.title] === 1)? 'Yes': (row['s1_data'][field.title]===0)? 'No': '-'}}</span>
                  <span v-else>
                    <span
                      v-if="row['s1_data']"
                      :class="(field.hasColor && row['color'][field.color])? 'f'+row['color'][field.color]: ''"
                    >{{(field.isNumeric)? getChecknFixed(row['s1_data'][field.title]): getLabel(row['s1_data'][field.title])}}</span>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.length===0">
            <tr>
              <td :colspan="tableFields.length">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- <div class="alert alert-danger" role="alert" v-else>No data found!</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker },
  mixins: [commonMixins, pCommonMixins],
  props: ["sectorList", "mcFilter", "title"],
  created() {
    if (localStorage.getItem("date") === null) {
      window.close();
    }
    console.log(this.sectorList);
    this.minRange = JSON.parse(localStorage.getItem("min"));
    this.ddate = localStorage.getItem("date");
    this.sectorname = localStorage.getItem("sector");
    this.maxRange = JSON.parse(localStorage.getItem("max"));
    this.selFilter[0] = "p11_actual";
    this.selFilter[1] = "q1_a_b_greater";
    this.selFilter[2] = "p11_quarterly_trends";
    this.selectedFil[0] = 0;
    this.min[0] = "";
    this.max[0] = "";
    this.selctedFiltersValue[0] = null;
    this.isFilterNumeric[0] = true;
    console.log(this.minRange, this.maxRange, this.sectorname, this.selFilter);
    console.log(this.min, this.max, this.selectedFil);
    this.tableFields = this.s1Data;
    this.getS1Data();
  },
  beforeDestroy() {
    console.log("Before destroy");
    // localStorage.removeItem("min");
    // localStorage.removeItem("date");
    // localStorage.removeItem("sector");
    // localStorage.removeItem("max");
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      tableFields: [],
      rawDataApi: "getS1SumData",
      apiUrl: "",
      rawData: {},
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: [],
      maxRange: [],
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: [],
      selectedFil: [],
      min: [],
      max: [],
      isFilterNumeric: [],
      selctedFiltersValue: [],
      selRangeFilter: 0,
      type: "s1",
      sectorData: [],
      sectorname: "",
      addedFilter: [{ title: "filter1", name: "Filter 1" }],
      textFilters: [],
      textFilter: [
        { title: "expanding", name: "Expanding" },
        { title: "contracting", name: "Contracting" },
        { title: "rangebound", name: "Rangebound" }
      ],
      textFilter1: [
        { title: "good", name: "Good" },
        { title: "not_good", name: "Not Good" }
      ],
      textFilter2: [
        { title: "heavy", name: "Heavy" },
        { title: "not_good", name: "Not Good" }
      ],
      textFilter3: [
        { title: "Consistent", name: "Consistent" },
        { title: "Inconsistent", name: "Inconsistent" }
      ],
      textFilter4: [{ title: "NT", name: "NT" }, { title: "T", name: "T" }],
      textFilter5: [
        { title: "GOVT", name: "GOVT" },
        { title: "NA", name: "NA" }
      ],
      textFilter6: [{ title: 1, name: "Yes" }, { title: 0, name: "No" }],
      s1Fields: [
        "market_capitalization",
        "p11_quarterly_trends",
        "q1_a_b_greater"
      ]
    };
  },
  methods: {
    getS1Data() {
      this.rawData = [];
      let myself = this;
      let data = {};
      data = {
        my_date: myself.getDate(myself.ddate),
        sector: myself.sectorname,
        m_filter: this.selFilter,
        min_range: this.minRange,
        max_range: this.maxRange,
        pageid: myself.page
      };
      http.post(myself.rawDataApi, data, (error, response) => {
        if (response.data.length > 0) {
          myself.rawData = response.data; //.slice(0, 500);
          myself.searchData = response.data; //.slice(0, 500);
          myself.ddate = myself.rawData[0]
            ? new Date(myself.rawData[0].date)
            : myself.ddate;
          console.log("tableheadings ", this.s1Data.length);
          myself.tableFields = this.s1Data;
          this.tableFields.forEach((val, key) => {
            console.log(key, val);
            if (
              val.title !== "date" &&
              val.title !== "_id" &&
              val.title !== "name" &&
              val.title !== "co_code" &&
              val.title !== "sector_name" &&
              val.title !== "color"
            ) {
              this.filterOptions.push({
                id: val.title,
                value: val.name,
                isNumeric: val.isNumeric,
                sort_order: key,
                filterType:
                  val.title === "latest_consistency_analysis"
                    ? "textFilter3"
                    : val.title === "capex_management"
                    ? "textFilter1"
                    : val.title === "assets_heavy_or_light"
                    ? "textFilter2"
                    : val.title === "latest_trends_more_than_or_equal_five_yes"
                    ? "textFilter4"
                    : val.title === "govtflag"
                    ? "textFilter5"
                    : val.title === "latest_cyclical"
                    ? "textFilter6"
                    : !val.isNumeric
                    ? "textFilter"
                    : ""
              });
            }
          });
          console.log("filters", this.filterOptions);
        }
      });
    },
    filtData(obj) {
      this.ddate = new Date(this.ddate);
      this.rawData = this.searchData;
      console.log(
        this.filterOptions,
        this.selctedFiltersValue,
        this.isFilterNumeric,
        this.selectedFil,
        this.min,
        this.max,
        this.textFilters
      );
      // this.getS1Data();
      var filteredData = [];
      this.isFilterNumeric.forEach((val, key) => {
        if (val) {
          var minRange = this.min[key];
          var maxRange = this.max[key];
          filteredData = this.rawData.filter(rd => {
            console.log(
              rd,
              key,
              this.filterOptions[this.selectedFil[key]].id,
              this.selectedFil[key],
              rd[this.filterOptions[this.selectedFil[key]].id],
              parseFloat(
                rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
              ),
              this.selRangeFilter,
              parseFloat(minRange),
              maxRange
            );
            if (minRange != "" && maxRange != "") {
              if (
                this.s1Fields.indexOf(
                  this.filterOptions[this.selectedFil[key]].id
                ) === -1
              ) {
                return (
                  parseFloat(
                    rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                  ) >= parseFloat(minRange) &&
                  parseFloat(
                    rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                  ) <= parseFloat(maxRange)
                );
              } else {
                consoe.log('else'+ rd[this.filterOptions[this.selectedFil[key]].id]);
                return (
                  parseFloat(
                    rd[this.filterOptions[this.selectedFil[key]].id]
                  ) >= parseFloat(minRange) &&
                  parseFloat(
                    rd[this.filterOptions[this.selectedFil[key]].id]
                  ) <= parseFloat(maxRange)
                );
              }
            } else {
              if (minRange != "") {
                if (
                  this.s1Fields.indexOf(
                    this.filterOptions[this.selectedFil[key]].id
                  ) === -1
                ) {
                  console.log(
                    "Only Min",
                    parseFloat(
                      rd["s1_data"][
                        this.filterOptions[this.selectedFil[key]].id
                      ]
                    ) >= parseFloat(minRange)
                  );
                  return (
                    parseFloat(
                      rd["s1_data"][
                        this.filterOptions[this.selectedFil[key]].id
                      ]
                    ) >= parseFloat(minRange)
                  );
                } else {
                  console.log(
                    "Only Min else",
                    parseFloat(
                      rd[this.filterOptions[this.selectedFil[key]].id]
                    ) >= parseFloat(minRange)
                  );
                  return (
                    parseFloat(
                      rd[this.filterOptions[this.selectedFil[key]].id]
                    ) >= parseFloat(minRange)
                  );
                }
              }
              if (maxRange != "") {
                console.log("Only Max");
                if (
                  this.s1Fields.indexOf(
                    this.filterOptions[this.selectedFil[key]].id
                  ) === -1
                ) {
                  return (
                    parseFloat(
                      rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                    ) <= parseFloat(maxRange)
                  );
                } else {
                  return (
                    parseFloat(rd[this.filterOptions[this.selectedFil[key]].id]) <=
                    parseFloat(maxRange)
                  );
                }
              }
            }
          });
        } else {
          console.log(this.textFilters[key]);
          // var filVal = this.textFilters[key];
          if (this.textFilters[key].length > 0) {
            var filVal = [];
            this.textFilters[key].forEach(ele => {
              if (
                this.filterOptions[this.selectedFil[key]].title ===
                "latest_cyclical"
              ) {
                filVal.push(parseInt(ele.title));
              } else {
                filVal.push(ele.title);
              }
            });
            filteredData = this.rawData.filter(rd => {
              console.log(
                rd,
                this.filterOptions[this.selectedFil[key]],
                filVal,
                rd["s1_data"][this.filterOptions[this.selectedFil[key]].id],
                filVal.includes(
                  rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                ),
                filVal.indexOf(
                  rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                ),
                filVal.includes(
                  rd[this.filterOptions[this.selectedFil[key]].id]
                )
              );
              if (filVal != "") {
                if (
                  this.s1Fields.indexOf(
                    this.filterOptions[this.selectedFil[key]].id
                  ) === -1
                ) {
                  return filVal.includes(
                    rd["s1_data"][this.filterOptions[this.selectedFil[key]].id]
                  );
                } else {
                  return filVal.includes(
                    rd[this.filterOptions[this.selectedFil[key]].id]
                  );
                }
              }
            });
          }
        }
        this.rawData = filteredData;
      });
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.name
              ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.sectorname = "";
      this.searchText = "";
      this.sectorname = "";
      this.searchText = "";
      this.selFilter[2] = "p11_quarterly_trends";
      this.ddate = new Date().setDate(new Date().getDate() - 1);
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] =
        "";
      this.rawData = this.searchData;
    },
    getDateData(e) {
      console.log("Date Selected", e);
    },
    addFilter() {
      var filtLen = this.addedFilter.length + 1;
      this.addedFilter.push({
        title: "filter" + filtLen,
        name: "Filter " + filtLen
      });
      this.selectedFil[this.addedFilter.length - 1] = 0;
      this.min[this.addedFilter.length - 1] = "";
      this.max[this.addedFilter.length - 1] = "";
      this.selctedFiltersValue[this.addedFilter.length - 1] = null;
      this.isFilterNumeric[this.addedFilter.length - 1] = true;
    },
    getFilterType(ind) {
      console.log("index", ind, this.addedFilter);
      const indx = this.selectedFil[ind];
      console.log("FilterOptions", indx, this.filterOptions[indx]);
      if (this.filterOptions[indx].isNumeric) {
        this.isFilterNumeric[ind] = true;
        this.selctedFiltersValue[ind] = null;
      } else {
        this.isFilterNumeric[ind] = false;
        this.textFilters[ind] = [];
        this.selctedFiltersValue[ind] = this[
          this.filterOptions[indx].filterType
        ];
      }
      console.log("Filter Val", this.selctedFiltersValue);
    },
    refreshData() {
      this.addedFilter = [{ title: "filter1", name: "Filter 1" }];
      this.selectedFil[0] = 0;
      this.min[0] = "";
      this.max[0] = "";
      this.selctedFiltersValue[0] = null;
      this.isFilterNumeric[0] = true;
      this.textFilters = [];
      this.selctedFiltersValue = [];
      this.rawData = this.searchData;
    },
    removeFilter(ind) {
      console.log(this.addedFilter);
      this.addedFilter.splice(ind, 1);
      console.log(this.addedFilter);
    }
  },
  watch: {
    sectorList(value) {
      this.sectorData = value;
    }
  },
  computed: {
    filterOptions0: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_actual";
      });
    },
    filterOptions1: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "q1_a_b_greater";
      });
    },
    filterOptions2: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_quarterly_trends";
        // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/s1-s-filtered.vue